export default __webpack_public_path__ + "static/media/instagram.f27ae419.png";